export default import.meta.ROLLDOWN_FILE_URL_0rYfam80Z_WvbGdZeAnvdw